export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./lk-mobile-notify.vue?vue&type=template&id=221bb673&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/base/modals/lk-mobile-notify.vue?vue&type=template&id=221bb673&
// module id = 1407
// module chunks = 0